import { Modalable, ResponseStatus } from './modalable';
import { QuickLinkSignFormData } from './quick-link-sign-form-data';

export class ModalableEdusuite implements Modalable {
    static MODAL_ID = 'eduSuiteSignModal';
    bypass = true;
    formData: QuickLinkSignFormData;
    status: ResponseStatus;
    storeUrl: string;
    trialUrl: string;

    getStatus(): ResponseStatus {
        return this.status;
    }

    getFormData(): QuickLinkSignFormData {
        return this.formData;
    }

    getModalId(): string {
        return ModalableEdusuite.MODAL_ID;
    }

    canBypassCheck(): boolean {
        return this.bypass;
    }
}
